const SITE_BRANDING_STORAGE_KEY = 'site_branding';

export const DEFAULT_SITE_BRANDING = {
  name: process.env.SITE_NAME || 'CRM',
  short_name: process.env.SITE_SHORT_NAME || process.env.SITE_NAME || 'CRM',
  description: process.env.SITE_DESCRIPTION || 'Hệ thống quản trị vận hành',
  theme_color: process.env.SITE_THEME_COLOR || '#2F80ED',
  logo_url: process.env.SITE_LOGO_URL || '/images/logo/logo.png',
  mobile_logo_url:
    process.env.SITE_MOBILE_LOGO_URL || process.env.SITE_APP_ICON_URL || '/images/logo/app-icon-180.png',
  favicon_url: process.env.SITE_FAVICON_URL || '/images/favicon.png',
  app_icon_url: process.env.SITE_APP_ICON_URL || '/images/logo/app-icon-180.png',
  internal_shipping_logo_url:
    process.env.SITE_INTERNAL_SHIPPING_LOGO_URL || process.env.SITE_LOGO_URL || '/images/logo/logo.png',
  rule_image_url: process.env.SITE_RULE_IMAGE_URL || '/images/rule.png',
  logo_max_height: process.env.SITE_LOGO_MAX_HEIGHT || '',
  order_prefix: process.env.SITE_ORDER_PREFIX || process.env.ORDER_PREFIX || '',
};

const normalizeString = (value, fallback = '') => {
  if (value === null || value === undefined) return fallback;
  const normalized = `${value}`.trim();
  return normalized || fallback;
};

export const normalizeSiteBranding = (branding = {}) => {
  const merged = { ...DEFAULT_SITE_BRANDING, ...(branding || {}) };

  return {
    name: normalizeString(merged.name, DEFAULT_SITE_BRANDING.name),
    short_name: normalizeString(merged.short_name, merged.name || DEFAULT_SITE_BRANDING.short_name),
    description: normalizeString(merged.description, DEFAULT_SITE_BRANDING.description),
    theme_color: normalizeString(merged.theme_color, DEFAULT_SITE_BRANDING.theme_color),
    logo_url: normalizeString(merged.logo_url, DEFAULT_SITE_BRANDING.logo_url),
    mobile_logo_url: normalizeString(
      merged.mobile_logo_url,
      merged.app_icon_url || merged.logo_url || DEFAULT_SITE_BRANDING.mobile_logo_url,
    ),
    favicon_url: normalizeString(merged.favicon_url, DEFAULT_SITE_BRANDING.favicon_url),
    app_icon_url: normalizeString(merged.app_icon_url, DEFAULT_SITE_BRANDING.app_icon_url),
    internal_shipping_logo_url: normalizeString(
      merged.internal_shipping_logo_url,
      merged.logo_url || DEFAULT_SITE_BRANDING.internal_shipping_logo_url,
    ),
    rule_image_url: normalizeString(merged.rule_image_url, DEFAULT_SITE_BRANDING.rule_image_url),
    logo_max_height: normalizeString(merged.logo_max_height, DEFAULT_SITE_BRANDING.logo_max_height),
    order_prefix: normalizeString(merged.order_prefix, DEFAULT_SITE_BRANDING.order_prefix),
  };
};

export const getStoredSiteBranding = () => {
  if (typeof window === 'undefined') return DEFAULT_SITE_BRANDING;

  try {
    const raw = window.localStorage.getItem(SITE_BRANDING_STORAGE_KEY);
    return raw ? normalizeSiteBranding(JSON.parse(raw)) : DEFAULT_SITE_BRANDING;
  } catch (_error) {
    return DEFAULT_SITE_BRANDING;
  }
};

export const storeSiteBranding = (branding) => {
  if (typeof window === 'undefined') return normalizeSiteBranding(branding);
  const normalized = normalizeSiteBranding(branding);
  window.localStorage.setItem(SITE_BRANDING_STORAGE_KEY, JSON.stringify(normalized));
  return normalized;
};

const upsertLink = (selector, attributes) => {
  if (typeof document === 'undefined') return;

  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement('link');
    document.head.appendChild(element);
  }

  Object.entries(attributes).forEach(([key, value]) => {
    element.setAttribute(key, value);
  });
};

const updateMeta = (selector, attribute, value) => {
  if (typeof document === 'undefined') return;
  const element = document.head.querySelector(selector);
  if (element) {
    element.setAttribute(attribute, value);
  }
};

export const applySiteBrandingToDocument = (branding) => {
  if (typeof document === 'undefined') return normalizeSiteBranding(branding);

  const normalized = normalizeSiteBranding(branding);
  document.title = normalized.name;
  updateMeta('meta[name="description"]', 'content', normalized.description);
  updateMeta('meta[name="theme-color"]', 'content', normalized.theme_color);
  updateMeta('meta[name="apple-mobile-web-app-title"]', 'content', normalized.short_name);

  upsertLink('link[rel="shortcut icon"]', {
    rel: 'shortcut icon',
    href: normalized.favicon_url,
  });
  upsertLink('link[rel="apple-touch-icon"]', {
    rel: 'apple-touch-icon',
    sizes: '180x180',
    href: normalized.app_icon_url,
  });

  return normalized;
};

export const getCurrentSiteBranding = () => normalizeSiteBranding(getStoredSiteBranding());

export const DEFAULT_APP_SWITCHER_ITEMS = [
  {
    id: 'erp',
    name: 'ERP',
    description: 'Quản lý vận hành',
    url: '{ERP_FRONTEND_URL}',
    icon: 'Briefcase',
    theme: 'theme-erp',
    theme_color: '#fba92c',
    bg_color: '#fff5e9',
    token_type: 'jwt_auth',
    redirect_path: '/dashboard',
    target: '_self',
    permission: 'all',
    allowed_roles: ['all'],
    is_active: true,
    sort_order: 1,
  },
  {
    id: 'hrm',
    name: 'HRM',
    description: 'Quản lý nhân sự',
    url: '{HR_FRONTEND_URL}',
    icon: 'Users',
    theme: 'theme-hrm',
    theme_color: '#33c40b',
    bg_color: '#f0f5ff',
    token_type: 'jwt_auth',
    redirect_path: '/dashboard',
    target: '_blank',
    permission: 'all',
    allowed_roles: ['all'],
    is_active: true,
    sort_order: 2,
  },
  {
    id: 'zalo_omni',
    name: 'Sale Chat',
    description: 'Inbox đa kênh',
    url: '',
    icon: 'MessageSquare',
    theme: 'theme-chat',
    theme_color: '#4e89ff',
    bg_color: '#f0f9f3',
    token_type: 'zalo_omni',
    redirect_path: '',
    target: '_blank',
    permission: 'sale_only',
    allowed_roles: ['sale', 'sale_leader'],
    is_active: true,
    sort_order: 3,
  },
  {
    id: 'zalo_salework',
    name: 'Zalo Sale Work',
    description: 'Tư vấn khách hàng',
    url: 'https://zalo.salework.net/',
    icon: 'MessageSquare',
    theme: 'theme-chat-2',
    theme_color: '#ea5455',
    bg_color: '#fff0f0',
    token_type: 'none',
    redirect_path: '',
    target: '_blank',
    permission: 'sale_only',
    allowed_roles: ['sale', 'sale_leader'],
    is_active: false,
    sort_order: 4,
  },
];



export const resolveAppUrl = (rawUrl, tokenType = 'none', redirectPath = '/dashboard') => {
  if (!rawUrl && tokenType !== 'zalo_omni') return '#';
  let processedUrl = rawUrl || '';

  if (processedUrl.includes('{ERP_FRONTEND_URL}')) {
    processedUrl = processedUrl.replace('{ERP_FRONTEND_URL}', process.env.ERP_FRONTEND_URL || '');
  }
  if (processedUrl.includes('{HR_FRONTEND_URL}')) {
    processedUrl = processedUrl.replace('{HR_FRONTEND_URL}', process.env.HR_FRONTEND_URL || '');
  }

  if (tokenType === 'jwt_auth') {
    const token = typeof window !== 'undefined' ? localStorage.getItem(process.env.TOKEN) : null;
    if (token && processedUrl && processedUrl !== '#') {
      const redirect = redirectPath || '/dashboard';
      const separator = processedUrl.includes('?') ? '&' : '?';
      return `${processedUrl}/auth/callback?token=${token}&redirect=${redirect}`;
    }
  }

  return processedUrl || '#';
};

